import React, { useState, useEffect } from 'react';
import { StudentAuthContext } from './StudentAuthContext';
import axiosConfig from '../api/axiosConfig';

export default function StudentAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('studentToken'));

  // Token'ı axios header'a ekle
  useEffect(() => {
    if (token) {
      axiosConfig.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axiosConfig.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Sayfa yüklendiğinde token varsa kullanıcı bilgilerini getir
  useEffect(() => {
    const checkAuth = async () => {
      const storedToken = localStorage.getItem('studentToken');
      
      if (storedToken) {
        try {
          console.log('StudentAuthProvider: Token found, checking auth...');
          
          // Token'ı set et
          setToken(storedToken);
          axiosConfig.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
          
          // Profil bilgilerini getir
          const response = await axiosConfig.get('/ogrenci/profile');
          console.log('Profile response:', response.data);
          setUser(response.data);
        } catch (error) {
          console.error('Auth check failed:', error);
          
          // Eğer 401 veya 403 hatası alırsak token'ı temizle
          if (error.response?.status === 401 || error.response?.status === 403) {
            console.log('Token invalid, clearing...');
            logout();
          }
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  // Giriş fonksiyonu
  const login = async (email, password) => {
    try {
      const response = await axiosConfig.post('/ogrenci/login', {
        email: email,
        password: password
      });

      console.log('Full response:', response);
      console.log('Response data:', response.data);

      const { token, ogrenci } = response.data;
      
      // Token'ı kaydet
      localStorage.setItem('studentToken', token);
      setToken(token);
      
      // Kullanıcı bilgilerini kaydet
      setUser(ogrenci);
      
      // Axios header'ı güncelle
      axiosConfig.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Giriş başarısız' 
      };
    }
  };

  // Çıkış fonksiyonu
  const logout = async () => {
    try {
      await axiosConfig.post('/ogrenci/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Her durumda local state'i temizle
      localStorage.removeItem('studentToken');
      setToken(null);
      setUser(null);
      delete axiosConfig.defaults.headers.common['Authorization'];
      // navigate kullanmak yerine window.location kullan
      window.location.href = '/student/login';
    }
  };

  // Profil güncelleme
  const updateProfile = async (profileData) => {
    try {
      const response = await axiosConfig.put('/ogrenci/update-profile', profileData);
      setUser(response.data.ogrenci);
      return { success: true, message: response.data.message };
    } catch (error) {
      console.error('Update profile error:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Güncelleme başarısız' 
      };
    }
  };

  // Şifre değiştirme
  const changePassword = async (currentPassword, newPassword) => {
    try {
      const response = await axiosConfig.put('/ogrenci/change-password', {
        currentPassword,
        newPassword
      });
      return { success: true, message: response.data.message };
    } catch (error) {
      console.error('Change password error:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Şifre değiştirme başarısız' 
      };
    }
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    updateProfile,
    changePassword,
    isAuthenticated: !!user
  };

  return (
    <StudentAuthContext.Provider value={value}>
      {children}
    </StudentAuthContext.Provider>
  );
}